import React from "react";
import { marqueeWords } from "../mock";

export default function Marquee() {
  const row = [...marqueeWords, ...marqueeWords];
  return (
    <div className="marquee">
      <div className="marquee-track">
        {row.map((w, i) => (
          <span key={`${w}-${i}`}>{w}</span>
        ))}
      </div>
    </div>
  );
}
